import React, { useState } from 'react'

import { MobilePaginationBlock } from 'src/common/components/MobilePaginationBlock/MobilePaginationBlock'
import { TextButton } from 'src/common/components/TextButton'
import { Resume } from 'src/graphql/types'

import { ResumesDrawer } from '../ResumesDrawer/ResumesDrawer'

import { ResumeCard } from './ResumeCard/ResumeCard'
import { ResumeCardEmpty } from './ResumeCardEmpty/ResumeCardEmpty'

import s from './ResumesCards.module.scss'

export type ResumesCardsProps = {
  resumes: Array<Resume>
  skillName: string
  developersCount: number
}

export const ResumesCards: React.FC<ResumesCardsProps> = ({
  resumes,
  skillName,
  developersCount,
}) => {
  const [selectedResume, setSelectedResume] = useState<Resume | null>(null)

  const handleClose = () => {
    setSelectedResume(null)
  }

  const handleViewProfile = (resume: Resume) => {
    return () => setSelectedResume(resume)
  }

  const renderElement = (element: Resume, index: number) => {
    const isEmptyCardShown = index === resumes.length - 1

    return (
      <React.Fragment key={index}>
        <ResumeCard {...element} onViewProfile={handleViewProfile(element)} />

        {isEmptyCardShown && (
          <ResumeCardEmpty
            publicName={skillName}
            developersCount={developersCount}
          />
        )}
      </React.Fragment>
    )
  }

  const renderShowMoreTrigger = (onShowMore: () => void) => (
    <TextButton onClick={onShowMore} className={s.ResumesCards__showMore}>
      View more JavaScript developers
    </TextButton>
  )

  return (
    <>
      <div className={s.ResumesCards}>
        <MobilePaginationBlock
          elements={resumes}
          elementsPerShow={3}
          paginationBreakpointMaxWidth={768}
          renderElement={renderElement}
          renderShowMoreTrigger={renderShowMoreTrigger}
        />
      </div>

      <ResumesDrawer
        isOpen={!!selectedResume}
        onClose={handleClose}
        resume={selectedResume}
      />
    </>
  )
}
